export interface RankingItem {
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: 'up' | 'down' | 'flat' | 'new';
  isTop?: boolean;
}

export interface TopicItem {
  id: string;
  tag: string;
  title: string;
  summary: string;
  image: string;
  reads: string;
  comments: string;
  time: string;
  hot: boolean;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface CategoryItem {
  name: string;
  icon: string;
  count: string;
  desc: string;
}

export interface BrandPoint {
  title: string;
  desc: string;
  icon: string;
}

export interface VoiceItem {
  name: string;
  role: string;
  content: string;
}

export const rankingList: RankingItem[] = [
  { rank: 1, title: '“顶流出道十年”正面硬刚：团队发长文逐条回应资源争议', category: '明星', heat: 9860, trend: 'new', isTop: true },
  { rank: 2, title: '综艺收官夜全员回归，热搜连爆三条，网友直呼“圆梦现场”', category: '综艺', heat: 9230, trend: 'up', isTop: true },
  { rank: 3, title: '神秘账号爆料年底演唱会档期，粉丝开启全网认领模式', category: '粉丝', heat: 8710, trend: 'up', isTop: true },
  { rank: 4, title: '悬疑剧《长夜将近》大结局遭泄底，片方紧急声明', category: '影视', heat: 7980, trend: 'up' },
  { rank: 5, title: '年轻演员同框活动生图流出，网友争论“妆造自由度”', category: '时尚', heat: 7420, trend: 'flat' },
  { rank: 6, title: '爆款带货主播翻车后首度直播，弹幕画风大反转', category: '网红', heat: 6890, trend: 'down' },
  { rank: 7, title: '经典老剧重启版官宣阵容，情怀粉与原著粉吵翻天', category: '影视', heat: 6550, trend: 'up' },
  { rank: 8, title: '体育圈再爆“转会连环瓜”，两家球迷俱乐部在线对线', category: '体育', heat: 6180, trend: 'up' },
  { rank: 9, title: '某品牌直播间工作人员失误，秒杀价货品被“薅秃”', category: '电商', heat: 5740, trend: 'down' },
  { rank: 10, title: '顶配阵容演唱会同台彩排花絮流出，乐迷翘首以待', category: '音乐', heat: 5310, trend: 'flat' },
];

export const hotTopics: TopicItem[] = [
  {
    id: 't1',
    tag: '头条热议',
    title: '热搜榜首之争：这届观众到底在为什么“上头”？',
    summary: '从官宣、剧透到售后一条龙，本期盘点朝阳吃瓜热门话题背后，究竟是内容本身够硬，还是围观情绪在推波助澜。',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20colorful%20neon%20city%20billboards%20with%20flickering%20text%20and%20crowd%20silhouettes%20at%20dusk%2C%20candid%20documentary%20style%2C%20vibrant%20warm%20tones%2C%20high%20detail&width=1600&height=1000&seq=chigua-hero-1&orientation=landscape',
    reads: '128万',
    comments: '6840',
    time: '2小时前',
    hot: true,
  },
  {
    id: 't2',
    tag: '明星',
    title: '片场“内卷”实录：凌晨三点还在对词，敬业还是作秀？',
    summary: '一张路透图引爆讨论，正反两派各执一词。朝阳吃瓜热议焦点回到“努力”二字，到底该被怎样定义。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20at%20night%20with%20director%20chair%2C%20reflector%20lights%20and%20blurred%20crew%2C%20documentary%20photography%2C%20moody%20warm%20lighting&width=1600&height=1000&seq=chigua-2&orientation=landscape',
    reads: '86万',
    comments: '4210',
    time: '4小时前',
    hot: true,
  },
  {
    id: 't3',
    tag: '综艺',
    title: '“天花板”回归：这档节目凭什么霸榜一整季？',
    summary: '被无数人反复盘点的名场面背后，藏着制作团队怎样的巧思？一场关于“好看的标准”的全民辩论正在上演。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20studio%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20celebrity%20reality%20show%20atmosphere%2C%20energetic%20editorial%20photography%2C%20warm%20golden%20tones&width=1600&height=1000&seq=chigua-3&orientation=landscape',
    reads: '73万',
    comments: '3590',
    time: '6小时前',
    hot: true,
  },
  {
    id: 't4',
    tag: '体育',
    title: '转会窗最后一天，压哨签约让全城“破防”',
    summary: '一纸官宣搅动整个朝阳吃瓜榜，支持声与质疑声同时刷屏，最新动态正持续发酵中。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stadium%20floodlights%20with%20green%20pitch%20and%20blurred%20jersey%20crowd%2C%20sports%20news%20editorial%20photo%2C%20bold%20high%20contrast%2C%20vivid%20teal%20and%20amber&width=1600&height=1000&seq=chigua-4&orientation=landscape',
    reads: '61万',
    comments: '2980',
    time: '8小时前',
    hot: false,
  },
  {
    id: 't5',
    tag: '网红',
    title: '直播带货“翻车”之后，真诚道歉能否挽回口碑？',
    summary: '品牌危机公关的一条龙操作被逐帧拆解，朝阳吃瓜头条热议着“翻车经济学”背后的信任成本。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20ring%20light%20and%20product%20shelf%2C%20soft%20bokeh%20background%2C%20commercial%20editorial%20photography%2C%20clean%20composition&width=1600&height=1000&seq=chigua-5&orientation=landscape',
    reads: '54万',
    comments: '2470',
    time: '10小时前',
    hot: false,
  },
  {
    id: 't6',
    tag: '时尚',
    title: '同款穿搭被“比美”，热搜背后的审美话语权之争',
    summary: '红毯生图与精修图对比流出，一场关于“真实与包装”的讨论登上朝阳吃瓜热议榜前排。',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20photography%20backstage%20with%20clothing%20rack%20and%20stylist%20hands%2C%20warm%20spotlight%2C%20magazine%20editorial%20feel%2C%20soft%20neutral%20tones&width=1600&height=1000&seq=chigua-6&orientation=landscape',
    reads: '42万',
    comments: '2130',
    time: '12小时前',
    hot: false,
  },
];

export const categories: CategoryItem[] = [
  { name: '明星八卦', icon: 'ri-star-smile-line', count: '1284条热议', desc: '台前幕后，真实与滤镜之间' },
  { name: '综艺现场', icon: 'ri-mic-line', count: '936条热议', desc: '名场面与“天花板”制造机' },
  { name: '影视娱乐', icon: 'ri-film-line', count: '1102条热议', desc: '热剧名场面实时追踪' },
  { name: '体育竞技', icon: 'ri-trophy-line', count: '758条热议', desc: '转会、赛场与全城狂热' },
  { name: '网红电商', icon: 'ri-shopping-bag-3-line', count: '642条热议', desc: '带货背后的流量江湖' },
  { name: '本地民生', icon: 'ri-map-pin-line', count: '871条热议', desc: '朝阳街头巷尾的新鲜事' },
];

export const brandPoints: BrandPoint[] = [
  { icon: 'ri-focus-3-line', title: '聚合不搬运', desc: '把散落全网的朝阳吃瓜热门话题集中呈现，快速定位当日最值得围观的“瓜”。' },
  { icon: 'ri-flashlight-line', title: '理性围观', desc: '朝阳吃瓜榜只呈现热度，不制造对立；每一条都标注来源与热度走势，帮助客观判断。' },
  { icon: 'ri-chat-smile-3-line', title: '跟上节奏', desc: '从朝阳吃瓜头条到热议焦点，让讨论节奏对得上，不错过每一次全民围观。' },
];

export const voices: VoiceItem[] = [
  { name: '小柚子', role: '常驻瓜友', content: '每天睡前刷一遍朝阳吃瓜榜，第二天跟同事聊天都不怕接不上话，节奏刚刚好。' },
  { name: '老白', role: '资深玩家', content: '比起一个个平台翻，我更爱直接看朝阳吃瓜热门话题汇总，省时又省心。' },
  { name: 'Momo酱', role: '综艺重度用户', content: '朝阳吃瓜头条更新得很及时，连热搜背后的来龙去脉都帮整理清楚了，爱了。' },
];

export const faqList: FaqItem[] = [
  {
    q: '朝阳吃瓜的热门话题多久更新一次？',
    a: '朝阳吃瓜榜与头条热议会实时聚合全网公开讨论热度，通常每 30 分钟刷新一轮排序，重大热点出现时会即时置顶，确保你看到的是当下最受关注的瓜。',
  },
  {
    q: '朝阳吃瓜榜的排序依据是什么？',
    a: '朝阳吃瓜榜综合了话题的讨论量、阅读量、传播速度与持续时间等公开信号加权计算，只反映热度趋势，不代表价值判断，帮助围观者快速了解当前焦点。',
  },
  {
    q: '我可以在平台上参与讨论或投稿吗？',
    a: '可以。你可以在热议焦点下方留言表达观点，也可以通过下方“我要投稿”表单把身边发生的、值得围观的新鲜事提供给编辑团队，审核后会展示在对应栏目中。',
  },
  {
    q: '内容来源可信吗？',
    a: '朝阳吃瓜只聚合转载公开发布、且标注了明确来源的讨论内容，并在关键话题上尽量提供多方视角，倡导理性吃瓜，不夸大、不造谣、不引导网暴。',
  },
  {
    q: '如何反馈问题或建议？',
    a: '无论是对榜单算法、内容审核还是页面体验有任何想法，都欢迎通过页面底部的联系方式或“我要投稿”表单与我们沟通，团队会认真对待每一条反馈。',
  },
];